import * as React from 'react';
import { isUndefined, classNames, ComponentClassName } from '@aws-amplify/ui';
import { Image } from '@aws-amplify/ui-react';
import { useStorageURL } from '@aws-amplify/ui-react/internal';
import { useSetUserAgent } from '@aws-amplify/ui-react-core';
import { VERSION } from '../../version.mjs';

const StorageImage = ({ accessLevel, className, fallbackSrc, identityId, imgKey, onStorageGetError, validateObjectExistence, ...rest }) => {
    const resolvedValidateObjectExistence = isUndefined(validateObjectExistence)
        ? true
        : validateObjectExistence;
    const options = React.useMemo(() => ({
        accessLevel,
        identityId,
        validateObjectExistence: resolvedValidateObjectExistence,
    }), [accessLevel, identityId, resolvedValidateObjectExistence]);
    useSetUserAgent({
        componentName: 'StorageImage',
        packageName: 'react-storage',
        version: VERSION,
    });
    const url = useStorageURL({
        key: imgKey,
        options,
        fallbackURL: fallbackSrc,
        onStorageGetError,
    });
    return (React.createElement(Image, { ...rest, className: classNames(ComponentClassName.StorageImage, className), src: url }));
};

export { StorageImage };
